import { handleSearch } from "Functions/functions";
import React, { useEffect, useState } from "react";
import { SearchMaterialIcon } from "../../../Icons/MaterialIcons";
import { ClearMaterialIcon } from "../../../Icons/MaterialIcons";
import "./Searcher.scss";

const Searcher = ({ items, setItems, setPage, setOnSearch }) => {
	const [originalItems, setOriginalItems] = useState(items);
	const [searchValue, setSearchValue] = useState("");
	const [flag, setFlag] = useState(false);

	useEffect(() => {
		if (items.length > 0 && !flag) {
			setOriginalItems(items);
			setFlag(true);
		}
	}, [items]);

	function mapItems() {
		var newItems = [];
		originalItems.forEach((item) => {
			const searchResult = handleSearch(item, searchValue.split(" "))
			searchResult && newItems.push(item);
		});
		return newItems;
	}

	function onEnter(event) {
		const itemsFound = mapItems();
		if (event.key === "Enter") {
			if (itemsFound.length === 0) {
				setItems([]);
				setPage(1)
				setOnSearch(true)
			} else {
				setItems(itemsFound);
				setOnSearch(true)
				setPage(1)
			}
			if (searchValue === "") {
				setItems(originalItems);
				setOnSearch(true)
				setPage(1)
			}
		}
	}

	function onSearch() {
		const itemsFound = mapItems();
		if (itemsFound.length === 0) {
			setItems([]);
			setPage(1)
			setOnSearch(true)
		} else {
			setItems(itemsFound);
			setPage(1)
			setOnSearch(true)
		}
		if (searchValue === "") {
			setItems(originalItems);
			setPage(1)
			setOnSearch(true)
		}
	}

	function handleResetInput() {
		setSearchValue("");
		setItems(originalItems);
		setPage(1)
		setOnSearch(false)
	}

	function onChange(event) {
		var value = event.target.value.toLowerCase();
		setSearchValue(value);
	}

	return (
		<div className="searcher">
			<input
				type="text"
				placeholder="Búsqueda"
				value={searchValue}
				onChange={onChange}
				onKeyPress={onEnter}
				className="searchInput"
			/>
			<ClearMaterialIcon
				fontSize="small"
				className="clearIcon"
				onClick={handleResetInput}
			/>
			<SearchMaterialIcon onClick={onSearch} className="searchIcon" />
		</div>
	);
};

export default Searcher;
